import { useState, useEffect } from "react";
import { CourseService } from "api/services/course";
import miscUtils from "utils/miscUtils";

export function useCourses(groupData: any) {
    const [courses, setCourses] = useState<any[]>([]);
    // was moved to this place because we were waiting too long for data updates

    useEffect(() => {
        if (groupData && miscUtils.isAdmin(groupData.user_membership)) {
            CourseService.getInstance()
                .getCourses(groupData && groupData.id)
                .then((response: any) => {
                    if (response && response.data.data) {
                        setCourses(response.data.data);
                    }
                }).catch((error: any) => console.error(error))
        }
    }, [groupData]);

    if (courses.length > 0) {
        return true
    }
    else {
        return false
    }
}
